'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUCCESS = exports.SUCCESS = 'SUCCESS';
var FAILURE = exports.FAILURE = 'FAILURE';
var PENDING = exports.PENDING = 'PENDING';
var TIMEOUT = exports.TIMEOUT = 'TIMEOUT';